module.exports = __webpack_public_path__ + "img/vectrex-lightpen.ea8f0627.jpg";